import { attr } from '@ember-data/model';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import Enum from '@square/dashboard-utilities/utils/enum';
import { UsageUnitType } from '@square/dashboard-data/models/squareup/sub2/usage';
export const UsageRuleType = new Enum(['MAX_USAGE']);
export const MaxUsageType = EmberDataBaseModel.extend({
  usageUnitType: attr(UsageUnitType),
  usageUnitCount: attr(Number)
});
export default EmberDataBaseModel.extend({
  type: attr(UsageRuleType),
  maxUsageRule: attr(MaxUsageType)
});